import { Link, NavLink, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Menu, X, Phone } from "lucide-react";

const links = [
  { to: "/", label: "Home" },
  { to: "/quotazioni", label: "Quotazioni" },
  { to: "/servizi", label: "Servizi" },
  { to: "/chi-siamo", label: "Chi Siamo" },
  { to: "/recensioni", label: "Recensioni" },
  { to: "/faq", label: "FAQ" },
  { to: "/contatti", label: "Contatti" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [pathname]);

  return (
    <nav
      data-testid="main-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-[#0a1628]/95 backdrop-blur-lg border-b border-white/5" : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-5 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 group">
          <div className="w-10 h-10 border border-[var(--gold)] flex items-center justify-center font-serif text-[var(--gold)] text-xl tracking-tight rotate-45 group-hover:rotate-90 transition-transform duration-500">
            <span className="-rotate-45 group-hover:-rotate-90 transition-transform duration-500">A</span>
          </div>
          <div className="flex flex-col leading-none">
            <span className="font-serif text-xl text-white tracking-wide">Affari Oro</span>
            <span className="text-[0.6rem] uppercase tracking-[0.3em] text-[var(--gold-soft)]">Modena</span>
          </div>
        </Link>

        <div className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `px-4 py-2 text-[0.78rem] uppercase tracking-[0.18em] transition-colors ${
                  isActive ? "text-[var(--gold)]" : "text-white/70 hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </div>

        <a
          href="tel:+393389472101"
          data-testid="nav-call-btn"
          className="hidden lg:inline-flex btn-gold !py-2.5 !px-5 !text-[0.7rem]"
        >
          <Phone size={14} /> 338 947 2101
        </a>

        <button
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          className="lg:hidden text-white"
          aria-label="menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0a1628] border-t border-white/5 px-6 py-6 space-y-2">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                `block py-3 text-sm uppercase tracking-[0.18em] border-b border-white/5 ${
                  isActive ? "text-[var(--gold)]" : "text-white/80"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
          <a href="tel:+393389472101" className="btn-gold w-full justify-center mt-4">
            <Phone size={14} /> Chiama Ora
          </a>
        </div>
      )}
    </nav>
  );
}
